<template>
  <div class="container">
    <div class="table-container">
      <div class="container-head">
        <el-button type="primary" @click="dialogFormVisible = true"
          >创建活动</el-button
        >
      </div>
      <el-table
        :data="tableData"
        stripe
        border=""
        height="600"
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="120"></el-table-column>
        <el-table-column prop="title" label="活动标题"></el-table-column>
        <el-table-column prop="description" label="活动简介"></el-table-column>
        <el-table-column prop="time" label="创建时间"></el-table-column>
        <el-table-column
          prop="expire_time_en"
          label="自动结束时间"
        ></el-table-column>
        <el-table-column prop="handle" label="类型"></el-table-column>
        <el-table-column prop="status_en" label="状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="btn-block">
              <el-popconfirm
                class="bottom"
                v-if="scope.row.status === 0 || scope.row.status === 200"
                confirmButtonText="确定"
                cancelButtonText="取消"
                icon="el-icon-info"
                iconColor="red"
                title="确定进行开始操作吗？"
                @onConfirm="handler(scope.row, 100)"
              >
                <el-button type="primary" slot="reference">开始</el-button>
              </el-popconfirm>
              <el-popconfirm
                class="bottom"
                v-if="scope.row.status === 100"
                confirmButtonText="确定"
                cancelButtonText="取消"
                icon="el-icon-info"
                iconColor="red"
                title="确定进行暂停操作吗？"
                @onConfirm="handler(scope.row, 200)"
              >
                <el-button type="warning" slot="reference">暂停</el-button>
              </el-popconfirm>
              <el-popconfirm
                v-if="scope.row.status === 100 || scope.row.status === 200"
                confirmButtonText="确定"
                cancelButtonText="取消"
                icon="el-icon-info"
                iconColor="red"
                title="确定进行结束操作吗？"
                @onConfirm="handler(scope.row, 999)"
              >
                <el-button type="danger" slot="reference">结束</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="创建活动" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="活动类型">
            <el-select
              @change="changeHandle"
              v-model="form.handle"
              placeholder="请选择活动类型"
            >
              <el-option
                v-for="(item, index) in selectList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="form.title" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="form.desc"
            ></el-input>
          </el-form-item>
          <el-form-item label="奖励">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="form.reward"
            ></el-input>
          </el-form-item>
          <el-form-item label="自动结束时间">
            <el-date-picker
              v-model="form.time"
              type="datetime"
              :picker-options="pickerOptions"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <label class="tip">选择将会自动结束活动</label>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="createActivity">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const ACTIVITY_TYPE = {
  invite: "邀请",
  sun_shines: "VIP上线普照",
  article_share: "VIP上线分享得会员",
  sun_shines2: "VIP上线2次普照"
};

import request from "../../api/request";
// import { format } from 'date-fns'
export default {
  data() {
    return {
      tableData: [],
      selectList: [],
      dialogFormVisible: false,
      form: {
        title: "",
        desc: "",
        reward: "",
        handle: "invite",
        time: ""
      },
      activity_type: Object.keys(ACTIVITY_TYPE).map(key => {
        return {
          label: ACTIVITY_TYPE[key],
          value: key
        };
      }),
      rules: {
        title: [
          { required: true, message: "请输入正确的信息", trigger: "blur" }
        ],
        desc: [{ required: true, message: "请输入正确的信息", trigger: "blur" }]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  created() {
    this.getItemList();
    this.getSelectList();
    this.changeHandle();
  },
  methods: {
    async getSelectList() {
      const resp = await request.activity.post("activity_handle_list");
      this.selectList = resp.data
    },
    async getItemList() {
      const params = {
        range: [0, 1e6]
      };
      const resp = await request.activity.post("activity_list", params);
      this.tableData = resp.data.list.map(item => {
        item.expire_time_en = item.expire_time
          ? item.expire_time
          : "无自动结束时间";
        switch (item.status) {
          case 0:
            item.status_en = "活动创建";
            break;
          case 100:
            item.status_en = "活动启用";
            break;
          case 200:
            item.status_en = "活动暂停";
            break;
          case 998:
            item.status_en = "自动结束";
            break;
          case 999:
            item.status_en = "活动结束";
            break;
          default:
            break;
        }
        return item;
      });
    },
    async createActivity() {
      this.$refs["form"].validate(async vaild => {
        if (vaild) {
          const params = {
            handle: this.form.handle,
            title: this.form.title,
            reward: JSON.parse(this.form.reward),
            desc: this.form.desc
          };
          if (this.form.time) {
            params.expire_time = this.form.time;
          }
          await request.activity.post("activity_create", params);
          this.dialogFormVisible = false;
          this.$message.success("创建成功");
          this.$refs["form"].resetFields();
          this.getItemList();
        }
      });
    },
    async changeHandle() {
      const resp = await request.activity.post("activity_default_reward_get", {
        handle: this.form.handle
      });
      this.form.reward = JSON.stringify(resp.data, null, 4);
    },
    async handler(row, status) {
      await request.activity.post("activity_status_set", {
        id: row.id,
        status: status
      });
      this.getItemList();
    }
  }
};
</script>

<style scoped>
.head {
  text-align: right;
  margin-bottom: 30px;
}
.item {
  width: 200px;
}
.table-container {
  height: 400px;
}
.container-head {
  margin-bottom: 20px;
}
.tip {
  color: red;
  margin-left: 10px;
}
.btn-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.btn-block > button {
  margin-bottom: 10px;
}
>>> .el-button + .el-button {
  margin-left: 0;
}
.bottom {
  margin-bottom: 10px;
}
</style>
